import React, { useEffect, useState } from 'react'
import { MoContainer, MoLink, MoSpan, Flag } from '../../Mo7/mo7UI'
import { cols, icons } from '../../services/design.sevice';
import { database } from '../../firebase';
import { useAuth } from '../../context/AuthContext';
import { useTrail } from '@react-spring/core';
import { animated } from '@react-spring/web';


export default function Announcements() {

    const [announcements, setAnnouncements] = useState([])
    const { currentUser } = useAuth()
    useEffect(() => {
        //get from database
        return database.announcements.where("uid", "==", currentUser.uid)
            .orderBy("createdAt", "desc")
            .onSnapshot(snapshot => {
                setAnnouncements(snapshot.docs.map(database.formattedDoc))
            })

    }, [currentUser.uid])

    const anim_announcements = useTrail(announcements.length, {
        from: {
            opacity:0,
            y: 100
        },
        to: {
            
            opacity:1,
            y: 0
        }
    })

    const domAnnouncements = announcements.map((ele, i) => {
        return (<animated.div style={anim_announcements[i]}><MoLink to={`/dashboard/edit-announcement/${ele?.id}`} key={ele?.id}>
            <MoContainer pos='relative' w="15rem" flex align="flex-end" justify="center" pd={{ b: '2rem' }}>
                <MoContainer pos='absolute' bg={cols.mainLight_1} z="-1" w="120%" h="6rem" pos_dir={{ t: "0" }} b_r={{ all: "1.2rem" }} />
                <MoContainer flex flex_dir_c border={{ w: "1px", col: cols.main_purple }} eff_shdw={{ op: .3 }} bg={cols.mainLight_4} b_r={{ all: "1.2rem" }} w="90%" m_t="2rem" >
                    <MoContainer bg_i={ele.photoURL} m_l="auto" m_r="auto" m_t="1rem" border={{ w: "2px", col: cols.main_purple }} b_r={{ all: "12rem" }} wh="6rem" />
                    <MoContainer w="100%" >
                        <MoContainer flex flex_dir_c pd={{ lr: "10px" }}>
                            <MoSpan fs_sml col="black"> {ele?.headline} </MoSpan>
                            <Flag text={ele?.subject} bg={cols.main_purple} />
                            <Flag text={`${ele?.price} $/hour`} bg={cols.mainLight_1} border={{ w: "1px", col: cols.greenSwamp }} col={cols.green} />
                            <MoContainer flex b_r={{ all: "3rem" }}>
                                {/* online */}
                                <MoContainer bg={cols.green} grid place="center" op={ele.isOnline ? "1" : ".25"} w="50%" h="2.5rem" flex b_r={{ tr: 0, br: 0, tl: "3rem", bl: "3rem" }}>
                                    <MoSpan fs_sml col="white" > Online </MoSpan>
                                </MoContainer>
                                {/* Offline */}
                                <MoContainer bg={cols.red} grid place="center" op={!ele.isOnline ? "1" : ".25"} w="50%" h="2.5rem" flex b_r={{ tl: 0, bl: 0, tr: "3rem", br: "3rem" }}>
                                    <MoSpan fs_sml col="white" > Offline </MoSpan>
                                </MoContainer>
                            </MoContainer>
                            <MoContainer grid place="center">
                                <MoSpan fs_sml >{ele.groupChatLabel}</MoSpan>
                            </MoContainer>
                        </MoContainer>
                    </MoContainer>

                </MoContainer>
            </MoContainer></MoLink></animated.div>
        )
    })



    return (
        <MoContainer>

            {/* Header */}
            <MoContainer h="5rem" flex align="center">
                <MoLink to='/dashboard/edit-announcement/create'> <MoContainer hvr={"background-color:" + cols.mainDark_2 + ";"} tra="background-color .2s;" sdw={{ x: "10px", y: "10px", sprd: "10px", op: 'rgba(0,0,0,0.25)' }} b_r={{ all: "1rem" }} bg={cols.mainLight_1} grid place="center" wh="4rem">
                    <img width="25px" src={icons.ic_plus} alt="" />
                </MoContainer>
                </MoLink>
                <MoSpan fs_mid m_r="auto" m_l="auto"> My Announcements </MoSpan>
            </MoContainer>
            {/* Announcement carts container */}
            <MoContainer flex gap="3rem" wrap="wrap" justify="space-evenly" m_t="5rem" >

                {/* Announcement cart container */}
                {domAnnouncements}

            </MoContainer>

        </MoContainer>
    )
}
